module.exports = __webpack_public_path__ + "assets/b79.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b79.png
// module id = 670
// module chunks = 0